// this is a general component that displays some loading skeletons when a widget is loading.. this keeps it in uniform
import React from "react";
import Skeleton from "react-loading-skeleton";
import { Card, Col } from "react-bootstrap";

const WidgetSkeleton = ({ cardHeight = "300px" }: Readonly<{ cardHeight: string | number }>) => (
    <Col xs={12} sm={12} md={6} lg={6} xl={4}>
        <Card className="overflow-hidden" style={{ height: cardHeight }}>
            <Card.Body>
                <Card.Title className="pb-2">
                    <Skeleton height={52} />
                </Card.Title>
                <Card.Text as="div" className="row g-1">
                    <Skeleton height={24} className="col-12" />
                    <Skeleton height={24} className="col-12" />
                    <Skeleton height={24} className="col-12" />
                    <Skeleton height={24} className="col-12" />
                    <Skeleton height={24} className="col-12" />
                    <Skeleton height={24} className="col-12" />
                </Card.Text>
            </Card.Body>
        </Card>
    </Col>
);

export default WidgetSkeleton;